import { ESharedComponent } from '../../../services/UI/State/ESharedComponent';
import { ILogState } from './ILogState';
import { State } from 'source/app/services/UI/State/State';
export function ResetEditableState() {
    const setState = State.ReadClass<ILogState>(ESharedComponent.Log)
        .setState;
    setState({
        showEditIcon: false,
        areLogEntriesEditable: false,
        dataHasChanged: true
    });
}
